export default {
  BOOK_BATCH_CANCEL_TIP: '一键结束“时间冲突的、已预约的”工位',
  BOOK_CANCEL_RESERVED_DESK: '取消已预约的工位',
  BOOK_GOTCHA: '知道了',
  MAP_MORE_DESK: '管理者设置：一次最多选{reserveCount}个工位',
  MAP_MORE_DESKS: '管理者设置：一次最多选{reserveCount}个工位',
  UNASSIGNED_STORAGE_LOCKER: '未分配储物柜'
}
